export default {
  shipmentConfirmPackings: (state) => state.shipmentConfirmPackings,
  searchConditions: (state) => state.searchConditions,
};
